import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';

export default makeStyles(theme => ({
  box: {
    maxWidth: '300px',
    position: 'absolute',
    backgroundColor: neutral.white,
    margin: 'auto',
    left: '0',
    right: '0',
    top: '105px',
    [theme.breakpoints.up('md')]: {
      maxWidth: ({ isPermissionUndefinedOrDenied }) =>
        isPermissionUndefinedOrDenied ? '35rem' : '17.5rem',
      top: '40px',
      left: '100px',
      right: 'auto',
    },
  },
  root: {
    display: 'flex',
    flexDirection: ({ isPermissionUndefinedOrDenied }) =>
      isPermissionUndefinedOrDenied ? 'row' : 'column',
    alignItems: 'center',
    fontFamily: 'Poppins',
    fontSize: '26px',
  },
  group: {
    textAlign: 'center',
  },
  icon: {
    padding: '30px 117px',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  tutorialImg: {
    margin: '20px',
    [theme.breakpoints.up('md')]: {
      display: ({ isPermissionUndefinedOrDenied }) =>
        isPermissionUndefinedOrDenied ? 'auto' : 'none',
    },
  },
  first: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
    marginTop: ({ isPermissionUndefinedOrDenied }) =>
      isPermissionUndefinedOrDenied ? '1.5rem' : '0',
  },
  second: {
    fontFamily: 'Poppins Bold',
    [theme.breakpoints.up('md')]: {
      display: ({ isPermissionUndefinedOrDenied }) =>
        isPermissionUndefinedOrDenied ? 'auto' : 'none',
      fontSize: '15px',
    },
  },
  text: {
    display: 'flex',
    fontSize: '15px',
    marginTop: ({ isPermissionUndefinedOrDenied }) =>
      isPermissionUndefinedOrDenied ? '0' : '20px',
    textAlign: 'center',
    padding: ({ isPermissionUndefinedOrDenied }) =>
      isPermissionUndefinedOrDenied ? '20px 20px 0 0' : '20px',
    [theme.breakpoints.up('md')]: {
      fontSize: '13px',
    },
  },
  cta: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    borderTop: ({ isPermissionUndefinedOrDenied }) =>
      isPermissionUndefinedOrDenied ? 'none' : `1px solid ${neutral[20]}`,
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row-reverse',
      display: ({ isPermissionUndefinedOrDenied }) =>
        isPermissionUndefinedOrDenied ? 'none' : 'auto',
    },
  },
  primary: {
    fontSize: '15px !important',
    fontFamily: 'Poppins',
    fontWeight: '600',
    [theme.breakpoints.up('md')]: {
      fontSize: '13px !important',
      padding: '5px 12px',
      flexDirection: 'row-reverse',
    },
  },
  cancelBtn: {
    fontFamily: 'Poppins',
    fontWeight: '600',
    color: neutral.D15,
    margin: '8px 0',
    [theme.breakpoints.up('md')]: {
      fontSize: '13px !important',
      padding: '5px 12px',
      margin: '0 20px',
    },
  },
}));
